import { Component, OnInit } from '@angular/core'
import {LocalStorageService} from '../../services/utils/local-storage.service'
import {Router} from '@angular/router'
import {ApplicationsService} from '../../services/applications.service'
import {LoadingService} from '../../services/utils/loading.service'
import {ErrorService} from '../../services/utils/error.service'
import {NavigateService} from '../../services/utils/navigate.service'
import { ConfigService } from '../../services/config.service'
import {ColorPaletteService} from '../../services/utils/color-palette.service';

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss']
})
export class ApplicationComponent implements OnInit {

  constructor(
      private loader: LoadingService,
      private localStorageService: LocalStorageService,
      private router: Router,
      private errorService: ErrorService,
      private config: ConfigService,
      private navigateService: NavigateService,
      private colorPaletteService: ColorPaletteService,
      public applicationsService: ApplicationsService
   ) { }

  async ngOnInit() {
    await this.loader.show()
    let applicationId = this.router.url.replace('/', '').split('?')[0]
    applicationId = this.config.webappPages.indexOf( applicationId ) >= 0 ? null : applicationId

    if ( applicationId ) {
      await this.loadApplication( applicationId )
    } else {
      const application = this.applicationsService.getCurrentApplication()
      if ( application && application.shortName && application.shortName.length > 0 ) {
        await this.loadApplication( application.shortName )
      } else if ( application && application.applicationId ) {
        await this.loadApplication( application.applicationId )
      } else {
        await this.loader.hide()
        return this.navigateService.goToNotFound()
      }
    }
  }

  async loadApplication( applicationId ) {
    this.applicationsService.loadApplication( applicationId ).subscribe( async ( res ) => {
      if ( !res ) {
        await this.loader.hide()
        return this.navigateService.goToNotFound()
      } else {
        await this.loader.hide()
        const theme = this.applicationsService.getTheme()

        const colorPaletteTheme: any = this.applicationsService.getCurrentApplication().validation.display?.colorPaletteTheme ?
            this.applicationsService.getCurrentApplication().validation.display.colorPaletteTheme : null
        this.colorPaletteService.updateThemePalette(colorPaletteTheme)

        if ( theme === 'covid' || theme === 'scanQrCode' || theme === 'desktop' || theme === 'debug' ) {
          return this.navigateService.goToTheme()
        } else {
          this.errorService.logError('Unknown application theme', {theme})
          return this.navigateService.goToNotFound()
        }
      }
    }, async (err) => {
      this.errorService.logError('Error while loading the application', err)
      await this.loader.hide()
      return this.navigateService.goToNotFound()
    })
  }

}
